import { createContext, useContext } from 'react';
import { useFetch } from '../components/common/requests.hooks';
import settingsAPI from '../services/settingsAPI';

const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
  const { data, isLoading, error, reloadData } = useFetch(settingsAPI.getAllProperties, { key: ['properties'], enabled: true });

  return (
    <PropertyContext.Provider value={{
        data,
        isLoading,
        error,
        reloadData
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export const usePropertyContext = () => useContext(PropertyContext);
